const footerDiv = document.querySelectorAll('.footer-block__details-content');
const wrapperSpan = document.createElement('div');
const spang = document.createElement('span');
const span2 = document.createElement('span');
if (window.location.href.startsWith('https://raicesibericas.com/fr')) {
  span2.textContent = 'Livraison gratuite pour les achats de plus de 50€';
} else if (window.location.href.startsWith('https://raicesibericas.com/en')) {
  span2.textContent = 'Free shipping on orders over 50€';
} else {
  span2.textContent = 'Envío gratuito a compras mayores a 50€';
}

wrapperSpan.classList.add('wrapper-span-footer-envios');

wrapperSpan.appendChild(span2);
footerDiv[2].appendChild(wrapperSpan);

if (window.location.href.startsWith('https://raicesibericas.com/fr')) {
  var footers = document.querySelectorAll('.footer-block__heading');
  var textoPolitica = document.querySelector('.politica-de-privacidad');

  if (footers.length > 3) {
    var tercerTitulo = footers.item(2);
    var cuartoTitulo = footers.item(3);
    tercerTitulo.textContent = 'Livraisons';
    cuartoTitulo.textContent = 'Mentions obligatoires';
    textoPolitica.textContent = 'Politique de confidentialité';
  }
}
